import { axiosInstance as axios } from "services";

export const fetchCartingPersonel = async () => {
  const { data } = await axios.get("/supplier/cartingPersonel");
  if (!data.success) throw new Error(data.error || "Failed to fetch carting personel");
  return data;
};

